module.exports = require("@hs/close-button");